
export const crudEndpoints = {

  READ_MANY: 'readMany',

  INSERT_BATCH: 'insertBatch',
  UPDATE_BATCH: 'updateBatch',
  DELETE_BATCH: 'removeBatch',

  REORDER: 'reorder',
  REORDER_DEEP: 'reorderDeep',
  SELECT: 'select',

} as const
